// const baseUrl = 'http://localhost:8000';
const baseUrl = process.env.REACT_APP_API_BASE_URL;

export default baseUrl;
